import { InfiniteData } from '@tanstack/query-core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { ArticlesPaginatedList } from '@shared/types/articles';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useArticleQuery = (params: EntityByIdParam) => {
  const methods = useQuery({
    queryKey: ['article', params.id],
    queryFn: async () => await API.articles.getById(params),
    enabled: typeof params?.id !== 'undefined',
  });

  useEffect(() => {
    queryClient.setQueriesData(
      { queryKey: ['articles'] },
      (oldData: InfiniteData<ArticlesPaginatedList>) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page) => ({
            ...page,
            results: page.results.map((item) =>
              item.id === methods.data?.id ? { ...item, ...methods.data } : item
            ),
          })),
        };
      }
    );
  }, [methods.data]);

  return methods;
};
